export default {
  state: {
    searching: false, // 是否重新搜索
    isSearch: false, // 是否有搜索条件
    keywords: { // 搜索参数
      ENGINE_NO: '',
      THCK: '',
      TH_WARE: '',
      CAR_GP: '',
      SH_WARE: '',
      DTR_TH: '',
      DTR_TH_F: '',
      DTR_TH_T: '',
      DTR_OVER: '',
      DTR_OVER_F: '',
      DTR_OVER_T: ''
    }
  },
  mutations: {
    setKeywords(state, payload) {
      
      state.isSearch = false
      state.searching = false
      for (let i in payload) {
        for (let j in state.keywords) {
          if (i === j) {
            if (payload[i]) state.isSearch = true
            if (payload[i] != state.keywords[j]) {
              state.searching = true
              state.keywords[j] = payload[i]
            }
          }
        }
      }
      console.log(payload,state.isSearch,state.searching);
    },
    clearSearch(state) {
      state.isSearch = false
      state.searching = false
      for (let i in state.keywords) {
        if (state.keywords[i]) state.searching = true
        state.keywords[i] = ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/search.js